module.exports = __webpack_public_path__ + "img/amex.b3abb55d.png";